import { render, staticRenderFns } from "./EditNoticeForm.vue?vue&type=template&id=1adae723&"
import script from "./EditNoticeForm.vue?vue&type=script&lang=js&"
export * from "./EditNoticeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports